import axios from 'axios'

interface IVerifyMfaParams {
  challengeToken: string
  code: string
  rememberDevice: boolean
}

const verifyMfa = async ({ challengeToken, code, rememberDevice }: IVerifyMfaParams) => {
  const apiUrl = `${process.env.REACT_APP_MAIN_API}/auth/login/verify-mfa`

  const response = await axios.post(
    apiUrl,
    {
      challenge_token: challengeToken,
      code,
      remember_device: rememberDevice,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )

  return response
}

export default verifyMfa
